export enum Role {
    Administrador = "Administrador",
    Kardex = "Kardex",
    JefaturaKardex = "JefaturaKardex",
    Sistemas = "Sistemas",
    AuxiliarTesoreria = "AuxiliarTesoreria",
    Contabilidad = "Contabilidad",
    // Maestro = "Maestro", no se ocupa mas este rol
    // MesaJubilacion = "MesaJubilacion", ya no se ocupa este rol, fusion con aux presidencia
    // Secretaria = "Secretaria", se cambio por mesa defuncion
    MesaDefuncion = "MesaDefuncion", 
    AuxiliarPresidencia = "AuxiliarPresidencia",
    Caja = "Caja", // Nuevo Rol añadido
    Archivo = "Archivo", // Nuevo Rol añadido
    Legal = "Legal", // Nuevo Rol añadido
    MesaTestamentacion = "MesaTestamentacion" // Nuevo Rol añadido
};